import type { ActionTypeHelper } from "../rootStore";

import type { MessageBoxParams } from "./reducer";
import { clearModalResult, openModal } from "./reducer";

export const showMessageBox =
  (params: MessageBoxParams): ActionTypeHelper<Promise<void>> =>
  async (dispatch, getState, extra) => {
    dispatch(openModal({ type: "message-box", params }));

    return new Promise<void>((resolve) => {
      let displayedModals = getState().modals.displayed;
      const { id } = displayedModals[displayedModals.length - 1];
      const unsubscribe = extra.store.subscribe(() => {
        const state = getState();
        // no changes in modal visibility, no need to check anything else
        if (state.modals.displayed === displayedModals) return;
        displayedModals = state.modals.displayed;
        if (id in state.modals.results) {
          unsubscribe();
          dispatch(clearModalResult(id));
          resolve();
        }
      });
    });
  };
